export default {
  "SetupGuide": "_SetupGuide_1u7r1_1",
  "CloseButton": "_CloseButton_1u7r1_10",
  "Steps": "_Steps_1u7r1_16",
  "Img": "_Img_1u7r1_25",
  "Guide": "_Guide_1u7r1_29",
  "Title": "_Title_1u7r1_33",
  "GuideLink": "_GuideLink_1u7r1_34"
};import "ni:sha-256;sznOC177IapmlemFjBB2T6h11YB7Jedq-a9iESBTMEI";